/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Abhishek Nair',
        title: 'Backend Engineer @ Instoried',
        text: "I have known Arshad since college time. The biggest strength I have seen in him is the ability to take up a task and work on it till its complete. Arshad was a quick learner too. This shows his dedication and learning ability which is in my opinion two most important things that help one progress professionally. So I believe he can add a great value to any organization he works for.",
        image: boy3
    },
    {
        id: 2,
        name: 'Gautam Gohil',
        title: 'Apiring Full Stack Web Developer',
        text: "Arshad and I studied together and I would like to say he is very kind and polite person and has excellent communication skills as well as problem solving skills. \n He is always ready to help others and also he always ensures that he give 100% efforts towards his works.\n I would definitely recommend Arshad and I would love to work with him as a team members.",
        image: boy2
    },
    {
        id: 3,
        name: 'Naved Khan',
        title: 'Apiring Full Stack Web Developer',
        text: "MD Arshad Khan is a very focused person. He is very funny as well as good at motivating people. When a person shares his thoughts with him, he can feel the positivity, and he also provides astounding advice. He has some really good analytical and problem-solving skills. I have observed lots of clarity in his concepts, along with his never-giving-up attitude towards any problem. \n I admire his work and would love to work with him on some upcoming projects. It will be a great experience.",
        image: boy1
    },
    {
        id: 4,
        name: 'P Punyacharan',
        title: 'Engineer - System Software, Satellite communications',
        text: "Arshad was my engineering batchmate and I've got opportunity to know him closely. He's a passionate developer and a dedicated engineer. I'm sure he'll add value to any organisation he'll be part of.\n I wish him all the best",
        image: boy3
    },
    {
        id: 5,
        name: 'Affan Ahmad',
        title: 'Apiring Full Stack Web Developer',
        text: "Arshad Khan, is a humble and amiable person. We used to discuss various topics while studying new topics.\n If he knows how to solve a problem, will solve and if he doesn't know, he will learn how to solve it and will solve. He is a dedicated and self-motivated person and is always ready to help others.",
        image: boy2
    },
    {
        id: 6,
        name: 'Abhinav Roy',
        title: 'Apiring Full Stack Web Developer',
        text: "I have worked with Arshad twice, he is a very polite and very good player as a team member who finishes his work on time. He is so responsible, for completing his work and also helps other members when needed. He is a well-mannered and disciplined person.",
        image: boy1
    }
]

